export enum ProductType {
    CULINARY = 'Culinary',
    GIFT_CARD_ELECTRONIC = 'GiftCard-Electronic',
    GIFT_CARD_PHYSICAL = 'GiftCard-Physical',
    HARD_GOOD = 'HardGood',
}
